import { createAsyncAction } from 'redux-promise-middleware-actions';
import { getActionTypesResult } from '../utils';
import api from '../Api/apiIS';

export const projectsConstants = {
    PROJECTS_LOADED_BY_ID: 'PROJECTS_LOADED_BY_ID'
};
export const projectsConstantsFulfilledConstants = getActionTypesResult(projectsConstants, '_FULFILLED');
export const projectsConstantsPendingConstants = getActionTypesResult(projectsConstants, '_PENDING');
export const projectsConstantsRejectedConstants = getActionTypesResult(projectsConstants, '_REJECTED');

export const fetchProjectsByUserId = createAsyncAction(
    projectsConstants.PROJECTS_LOADED_BY_ID,
    userId =>
        api.get(`projects/user/${userId}`)
            .then(response => ({
                data: response.data,
                userId,
            })),
    userId => userId
);
